import { Suspense } from 'react';
import AllRoutes from '../app/routers/AllRoutes';

const Views = () => {
  const Style = {
    width: '100%', 
    height: '100vh',
    color: 'var(--color-text-secondary)',
    display: 'flex',
    alignItems: 'center', 
    justifyContent: 'center'
  }

  return (
    <Suspense fallback={<div style={Style}>Loading...</div>}>
      <AllRoutes />
    </Suspense>
  );
};

export default Views;